import { Value } from 'react-svg-pan-zoom';
import { Bubble, BubbleStatus, ProjectLimits } from '../../../../modules/Bubbles/Bubbles.types';
import { Components } from '../../../../utils/types';

export const INITIAL_VALUE: Value = {
    version: 2,
    mode: 'idle',
    focus: false,
    a: 0,
    b: 0,
    c: 0,
    d: 0,
    e: 0,
    f: 0,
    viewerWidth: 1600,
    viewerHeight: 900,
    SVGWidth: 1600,
    SVGHeight: 900,
    miniatureOpen: false,
};

export const demoBubble2: Bubble = {
    id: '01936a18-a3cc-7dad-9592-761d6f6b5529',
    name: 'WbsElem 1',
    start: {
        x: 70,
        y: 50,
        radius: 60,
    },
    end: { x: 120, y: 170, constSt: false },
    completion: 30,
    constSt: false,
    endStatus: 'yellow',
    qualityStatus: 'green',
    startStatus: 'yellow',
};

export const getLimitsFromProjectSettings = (settings?: Components.Schemas.ProjectSettingDTO): ProjectLimits => ({
    benefit: {
        cautionMin: settings?.timeCautionMinimumTreshold,
        critalMin: settings?.benefitCriticalMinimumTreshold,
        cautionMax: settings?.benefitCautionMaximumTreshold,
        critalMax: settings?.benefitCriticalMaximumTreshold,
    },
    cost: {
        cautionMin: settings?.costCautionMinimumTreshold,
        critalMin: settings?.costCriticalMinimumTreshold,
        cautionMax: settings?.costCautionMaximumTreshold,
        critalMax: settings?.costCriticalMaximumTreshold,
        extremeMax: settings?.costExtremeMaximumTreshold,
        extremeMin: settings?.costExtremeMinimumTreshold,
    },
    quality: {
        cautionMin: settings?.qualityCautionMinimumTreshold,
        critalMin: settings?.qualityCriticalMinimumTreshold,
        cautionMax: settings?.qualityCautionMaximumTreshold,
        critalMax: settings?.qualityCriticalMaximumTreshold,
    },
    scope: {
        cautionMin: settings?.scopeCautionMinimumTreshold,
        critalMin: settings?.scopeCriticalMinimumTreshold,
        cautionMax: settings?.scopeCautionMaximumTreshold,
        critalMax: settings?.scopeCriticalMaximumTreshold,
    },
    time: {
        cautionMin: settings?.timeCautionMinimumTreshold,
        critalMin: settings?.timeCriticalMinimumTreshold,
        cautionMax: settings?.timeCautionMaximumTreshold,
        critalMax: settings?.timeCriticalMaximumTreshold,
        extremeMax: settings?.timeExtremeMaximumTreshold,
        extremeMin: settings?.timeExtremeMinimumTreshold,
    },
});

export const demoBubble: Bubble = {
    id: '01936a18-a3c7-7202-81df-b0249a6b9b38',
    name: 'WbsElem 4',
    start: {
        x: 160, //  actualDeltaTimePercent
        y: 160, // actualDeltaCostPercent
        radius: 100, //bubble radius * scale
    },
    end: {
        x: 300,
        // deltaCostPercent
        y: 300, // deltaTimePercent
        constSt: false, // not used?
    },
    completion: 70, // degreeOfCompletion
    constSt: true, // constraintCostInfringed, constraintEndInfringed constraintStartInfringed  constraintQualityInfringed
    endStatus: 'red', // not used?
    qualityStatus: 'green', // deltaQualityState
    startStatus: 'red', // deltaCostState + deltaTimeState
};

export const getBubbles = (element: Components.Schemas.WBSElementDeltaDTO): Bubble => {
    return {
        id: element.id ?? '-',
        name: element.name ?? '-',
        completion: element.degreeOfCompletion ?? 0,
        start: {
            radius: element.bubbleRadius ?? 0,
            x: element.actualDeltaTimePercent ?? 0,
            y: element.actualDeltaCostPercent ?? 0,
        },
        end: {
            constSt: false,
            x: element.deltaCostPercent ?? 0,
            y: element.deltaTimePercent ?? 0,
        },
        constSt:
            !!element.constraintCostInfringed ||
            !!element.constraintEndInfringed ||
            !!element.constraintStartInfringed ||
            !!element.constraintQualityInfringed,
        endStatus: 'red',
        qualityStatus: getStateColor(element.deltaQualityState),
        startStatus: getStateColor(element.deltaCostState),
    };
};

export const getStateColor = (state?: Components.Schemas.DeltaStateType): BubbleStatus => {
    switch (state) {
        case 'CriticalMaximum':
        case 'CautionMaximum':
            return 'red';
        case 'CriticalMinimum':
        case 'CautionMinimum':
            return 'yellow';
        case 'DivisionByZero':
        case 'Normal':
        default:
            return 'green';
    }
};
